var exports = {
  "oM": "IndicatorsTab.module__itemsWrapper___ZHNrbm",
  "tz": "IndicatorsTab.module__itemTextTertiary___ZHNrbm",
  "Bp": "IndicatorsTab.module__avatarGroup___ZHNrbm",
  "hD": "IndicatorsTab.module__stacksWrapper___ZHNrbm",
  "KE": "IndicatorsTab.module__stackItem___ZHNrbm",
  "U3": "IndicatorsTab.module__badgesWrapper___ZHNrbm",
};

module.exports = exports;
